export default {
  'app.settings.menuMap.basic': 'Basic Settings',
  'app.settings.menuMap.security': 'Security Settings',
  'app.settings.menuMap.binding': 'Account Binding',
  'app.settings.menuMap.notification': 'New Message Notification',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Change avatar',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Please input your email!',
  'app.settings.basic.nickname': 'Nickname',
  'app.settings.basic.nickname-message': 'Please input your Nickname!',
  'app.settings.basic.profile': 'Personal profile',
  'app.settings.basic.profile-message': 'Please input your personal profile!',
  'app.settings.basic.profile-placeholder': 'Brief introduction to yourself',
  'app.settings.basic.country': 'Country/Region',
  'app.settings.basic.country-message': 'Please input your country!',
  'app.settings.basic.geographic': 'Province or city',
  'app.settings.basic.geographic-message': 'Please input your geographic info!',
  'app.settings.basic.address': 'Street Address',
  'app.settings.basic.address-message': 'Please input your address!',
  'app.settings.basic.phone': 'Phone Number',
  'app.settings.basic.phone-message': 'Please input your phone!',
  'app.settings.basic.update': 'Update Information',
  'app.settings.security.strong': 'Strong',
  'app.settings.security.medium': 'Medium',
  'app.settings.security.weak': 'Weak',
  'app.settings.security.password': 'Account Password',
  'app.settings.security.password-description': 'Current password strength',
  'app.settings.security.phone': 'Security Phone',
  'app.settings.security.phone-description': 'Bound phone',
  'app.settings.security.question': 'Security Question',
  'app.settings.security.question-description':
    'The security question is not set, and the security policy can effectively protect the account security',
  'app.settings.security.email': 'Backup Email',
  'app.settings.security.email-description': 'Bound Email',
  'app.settings.security.email-unbound': 'No email bound',
  'app.settings.security.email-update-title': 'Update Email',
  'app.settings.security.email-required': 'Please input your email',
  'app.settings.security.email-invalid': 'Email format is invalid',
  'app.settings.security.email-input-placeholder': 'Please input your email',
  'app.settings.security.email-update-success': 'Email updated successfully',
  'app.settings.security.email-update-failed': 'Failed to update email',
  'app.settings.security.mfa': 'MFA Device',
  'app.settings.security.mfa-description':
    'Unbound MFA device, after binding, can be confirmed twice',
  'app.settings.security.mfa-enabled-description':
    'An OTP device is already linked for multi-factor verification',
  'app.settings.security.modify': 'Modify',
  'app.settings.security.change-password': 'Change Password',
  'app.settings.security.otp-title': 'OTP Management',
  'app.settings.security.otp-bind': 'Bind OTP',
  'app.settings.security.otp-manage': 'Manage OTP',
  'app.settings.security.otp-setup-description':
    'Scan the QR code with Google Authenticator or Microsoft Authenticator, then enter the 6-digit code to finish setup.',
  'app.settings.security.otp-load-failed': 'Failed to load OTP QR code',
  'app.settings.security.otp-qr-unavailable':
    'QR code is unavailable, please use the manual key instead',
  'app.settings.security.otp-manual-key': 'Manual entry key',
  'app.settings.security.otp-code': '6-digit code',
  'app.settings.security.otp-code-required': 'Please input the 6-digit code',
  'app.settings.security.otp-code-invalid': 'The code must be 6 digits',
  'app.settings.security.otp-code-placeholder':
    'Please input the verification code',
  'app.settings.security.otp-refresh-qr': 'Refresh QR Code',
  'app.settings.security.otp-enable': 'Enable OTP',
  'app.settings.security.otp-enable-success': 'OTP has been enabled',
  'app.settings.security.otp-enable-failed': 'Failed to enable OTP',
  'app.settings.security.otp-enabled-title': 'OTP is enabled',
  'app.settings.security.otp-enabled-description':
    'This account already has an OTP device linked. Enter your current password to disable it.',
  'app.settings.security.otp-disable': 'Disable OTP',
  'app.settings.security.otp-disable-success': 'OTP has been disabled',
  'app.settings.security.otp-disable-failed': 'Failed to disable OTP',
  'app.settings.security.otp-disable-password': 'Current Password',
  'app.settings.security.otp-disable-password-required':
    'Please input your current password to disable OTP',
  'app.settings.security.otp-disable-password-placeholder':
    'Please input your current password',
  'app.settings.security.otp-binding': 'OTP Binding',
  'app.settings.security.otp-binding-title': 'Bind OTP Authenticator',
  'app.settings.security.otp-binding-subtitle':
    'To protect your account security, please bind an OTP authenticator',
  'app.settings.security.otp-binding-alert':
    'Please use Google Authenticator or Microsoft Authenticator to scan the QR code',
  'app.settings.security.old-password': 'Current Password',
  'app.settings.security.old-password-required':
    'Please input your current password',
  'app.settings.security.old-password-placeholder':
    'Please input your current password',
  'app.settings.security.new-password': 'New Password',
  'app.settings.security.new-password-required':
    'Please input your new password',
  'app.settings.security.new-password-placeholder':
    'Please input your new password',
  'app.settings.security.confirm-password': 'Confirm New Password',
  'app.settings.security.confirm-password-required':
    'Please confirm your new password',
  'app.settings.security.confirm-password-placeholder':
    'Please confirm your new password',
  'app.settings.security.confirm-password-mismatch':
    'The new passwords do not match',
  'app.settings.security.password-rule':
    '8-20 characters with uppercase, lowercase, number, and special character @$!%*?&',
  'app.settings.security.password-different':
    'The new password must differ from the current password',
  'app.settings.security.change-password-success':
    'Password changed successfully',
  'app.settings.security.change-password-failed': 'Failed to change password',
  'app.settings.security.submit': 'Confirm',
  'app.settings.security.cancel': 'Cancel',
  'app.settings.security.set': 'Set',
  'app.settings.security.bind': 'Bind',
  'app.settings.binding.taobao': 'Binding Taobao',
  'app.settings.binding.taobao-description': 'Currently unbound Taobao account',
  'app.settings.binding.alipay': 'Binding Alipay',
  'app.settings.binding.alipay-description': 'Currently unbound Alipay account',
  'app.settings.binding.dingding': 'Binding DingTalk',
  'app.settings.binding.dingding-description':
    'Currently unbound DingTalk account',
  'app.settings.binding.bind': 'Bind',
  'app.settings.notification.password': 'Account Password',
  'app.settings.notification.password-description':
    'Messages from other users will be notified in the form of a station letter',
  'app.settings.notification.messages': 'System Messages',
  'app.settings.notification.messages-description':
    'System messages will be notified in the form of a station letter',
  'app.settings.notification.todo': 'To-do Notification',
  'app.settings.notification.todo-description':
    'The to-do list will be notified in the form of a letter from the station',
  'app.settings.open': 'Open',
  'app.settings.close': 'Close',
};
